import { toRelativeURL } from '@/components/ActivityViewers/utils/toRelativeURL'
import { log } from '../log'

export const normalizeImageSrcToOrigin = (element?: HTMLDivElement) => {
  if (element) {
    const images = element.getElementsByTagName('img') as HTMLCollectionOf<HTMLImageElement>

    for (let i = 0, len = images.length; i < len; i++) {
      if (!images[i].src) continue

      try {
        const url = new URL(images[i].src)
        const isInternal = url.origin === window.location.origin

        if (isInternal) {
          continue
        }

        const relativeURL = toRelativeURL(url.href)
        const parsedURL = new URL(relativeURL, window.location.origin)
        images[i].src = parsedURL.href
      } catch {
        log('[EditorJS] broken image source', images[i].src)
      }
    }
  }
}
